import React, {useContext} from "react"
import Row from "@amzn/meridian/row";
import RouteState from "./RouteState";
import {RouteFilterContext} from "./context/RouteFilterContext";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {AR_V2, HEADERS} from "../util/Constants";
import RouteViewFilter from "./RouteViewFilter";
import Column from "@amzn/meridian/column";
import {RouteContext} from "./context/RouteContext";
import RefreshTimer from "../util/RefreshTimer";
import PageHeader from "../util/PageHeader";

const Route = () => {
    const { viewModelRouteFilter } = useContext(RouteFilterContext)
    const {configViewModel} = useContext(CapabilityContext)
    const { viewModel } = useContext(RouteContext)

    const getCardRowForAMZL = () => {
        return (
            <Row widths={["grid-2", "grid-2", "grid-2", "grid-2", "grid-2"]}>
                <RouteState detail={{state: "route.induct", message: "Induct", type: "Normal"}}/>
                <RouteState detail={{state: "route.stowed", message: "Stowed", type: "Normal"}}/>
                {viewModelRouteFilter.selectedRouteType[0] === 'Core' ?
                    [
                        <RouteState detail={{state: "route.picked", message: "Picked", type: "Normal"}}/>,
                        <RouteState detail={{state: "route.staged", message: "Staged", type: "Normal"}}/>
                    ] : null
                }
                <RouteState detail={{state: "route.departed", message: "Departed", type: "Normal"}}/>
            </Row>)
    }

    const getCardRowForARv2 = () => {
        return (
            <Row widths={["grid-2", "grid-2", "grid-2", "grid-2", "grid-2"]}>
                <RouteState detail={{state: "route.induct", message: "Induct", type: "Normal"}}/>
                <RouteState detail={{state: "route.picked", message: "Picked", type: "Normal"}}/>
                <RouteState detail={{state: "route.stowed", message: "Stowed", type: "Normal"}}/>
                <RouteState detail={{state: "route.staged", message: "Staged", type: "Normal"}}/>
                <RouteState detail={{state: "route.departed", message: "Departed", type: "Normal"}}/>
            </Row>)
    }

    return (
        <Column spacingInset="none large" spacing="small">
            <PageHeader {...HEADERS.ROUTES}/>
            <RouteViewFilter/>
            <RefreshTimer deps={[viewModel]}/>
            {configViewModel.capability === AR_V2 ?
                getCardRowForARv2()
                :
                getCardRowForAMZL()
            }
        </Column>
    )
}

export default Route;


// WEBPACK FOOTER //
// ./src/components/routeView/Route.js